import type * as CSS from "csstype";
import {IMyopComponent} from "../host";
import {uuidv4} from "../utils/utils.ts";
import {ExecuteScriptMessage} from "../messages";

// ignoring documentation
/** @ignore */
export interface CSSProperties extends CSS.Properties<string | number> {
}

export type StylesheetDefinition = { [key: string]: CSSProperties };

export const applyStylesheet = (component: IMyopComponent, stylesheet: StylesheetDefinition, css?: string) => {
    const tagId = `myop-css-${uuidv4()}`;
    component.send(new ExecuteScriptMessage(({rootRef, _stylesheet, _tagId, _css}) => {
        const styleTag = document.createElement('style');
        styleTag.type = 'text/css';

        // Build the CSS string from the styles object
        let cssString = _css;

        for (const selector in _stylesheet) {
            cssString += `${selector} { `;
            const properties = _stylesheet[selector];
            for (const property in properties) {
                cssString += `${property}: ${properties[property]}; `;
            }
            cssString += '} ';
        }

        // Set the CSS string as the content of the <style> element
        styleTag.appendChild(document.createTextNode(cssString));
        styleTag.id = _tagId;
        // Append the <style> element
        (rootRef.shadowRoot || rootRef.container).appendChild(styleTag);

    }, () => {
    }, {
        _stylesheet: stylesheet,
        _css : css ? css : '',
        _tagId: tagId
    }));

    return () => {
        component.send(new ExecuteScriptMessage(({rootRef, _tagId}) => {
            const element = (rootRef.shadowRoot || document).getElementById(_tagId);
            if (element) {
                element.remove();
            }
        }, () => {
        }, {
            _tagId: tagId
        }))
    }
}

export const applyStylesheetLink = (component: IMyopComponent, link: string) => {
    const tagId = `myop-css-${uuidv4()}`;
    component.send(new ExecuteScriptMessage(({rootRef, _tagId, _link}) => {
        const linkElement = document.createElement('link');
        linkElement.id = _tagId;
        linkElement.rel = 'stylesheet';
        linkElement.href = _link;
        document.head.appendChild(linkElement);

        // Append the <style> element
        (rootRef.shadowRoot || rootRef.container).appendChild(linkElement);
    }, () => {
    }, {
        _link : link,
        _tagId: tagId
    }));

    return () => {
        component.send(new ExecuteScriptMessage(({rootRef, _tagId}) => {
            const element = (rootRef.shadowRoot || document).getElementById(_tagId);
            if (element) {
                element.remove();
            }
        }, () => {
        }, {
            _tagId: tagId
        }))
    }
}
